export default "__VITE_ASSET__CiE285ZI__"